import { useEffect, useState } from "react";
import { Button, Form, Input } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";
import { GetUrlParams } from "scripts/helpers";
import { Patterns } from "scripts/settings";

const Component = () => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { submitting } = state;
	const { search } = useLocation();
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				API.auth
					.getOtp(values)
					.then(() => {
						navigate({
							pathname: "/auth/reset",
							search: `?mobile=${values.phone}`,
						});
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	return (
		<div className="wrapper">
			<img src="/images/logo-black.png" alt="Shop" className="brand" />
			<h1 className="heading">{`${Resources.enter} ${Resources.to} ${Resources.account}`}</h1>
			<Form form={form} layout="vertical">
				<Form.Item name="phone" label={Resources.mobile} rules={Rules.mobile}>
					<Input type="tel" size="large" placeholder={Resources.mobile} />
				</Form.Item>

				<Form.Item style={{ paddingTop: 16 }}>
					<Button
						type="primary"
						size="large"
						loading={submitting}
						onClick={handleSubmit}
						block
					>
						{Resources.enter}
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};

export default Component;
